import React, { useState, useEffect, useCallback } from "react";
import MainLayout from "../../Layout/mainLayout";
import DateRangePopup from "../../Utils/dateFilterPopup";
import { columnsBookings } from "../../Global Functions/columnsAntd";
import { Table } from "antd";
import "./listBookings.css";
import { getBookingsList } from "../../Redux/Actions/bookingActions";
import { useDispatch, useSelector } from "react-redux";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { icons } from "../../icons";
// import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import BookingSourceDropdown from "../Bookings/dropDown";


const ListBookings = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [bookingFrom, setBookingFrom] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const { bookings, loading } = useSelector((state) => state.bookings);

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });


  const fetchDetails = useCallback(
    async (page, limit, showLoader = true) => {
      const bookingData = {
        page,
        limit,
        is_deleted: false,
        filter: debouncedSearch,
        ...(bookingFrom && { booking_from: bookingFrom }),
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      try {
        await dispatch(getBookingsList(bookingData, showLoader));

        if (!showLoader) {
          // toast.success("Bookings list refreshed");
        }
      } catch {
        if (!showLoader) {
          // toast.error("Failed to refresh bookings list");
        }
      }
    },
    [dispatch, debouncedSearch, bookingFrom, dateRange]
  );

  useEffect(() => {
    fetchDetails(
      pagination.current,
      pagination.pageSize,
      false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.current,
    pagination.pageSize,
    debouncedSearch,
    bookingFrom,
    dateRange,
    fetchDetails,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    if (bookings?.total) {
      setPagination((prevData) => ({ ...prevData, total: bookings.total }));
    }
  }, [bookings]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };


  const handleDownloadBookingsExcelWithDateRange = async () => {
    try {
      const bookingData = {
        page: pagination.current,
        limit: pagination.pageSize,
        filter: debouncedSearch,
        ...(bookingFrom && { booking_from: bookingFrom }),
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
        is_deleted: false,
      };

      await dispatch(getBookingsList(bookingData));

      const rawBookingData = bookings?.data?.result || [];
      if (!Array.isArray(rawBookingData) || rawBookingData.length === 0) {
        alert("No booking data available to download");
        return;
      }

      const preparedData = rawBookingData.map((booking) => ({
        booking_id: booking.booking_id,
        customer_name: booking.user?.name || "",
        customer_email: booking.user?.email || "",
        customer_country_code: booking.user?.country_code || "",
        customer_contact_number: booking.user?.contact_number || "",
        booking_date: booking.created_at ? new Date(booking.created_at).toLocaleString() : "",
        status: booking.booking_status || "",
        project_name: booking.project?.project_name || "",
        city: booking.city?.city_name || "",
        country: booking.country?.country_name || "",
        booking_amount: booking.booking_amount || 0,
        payment_status: booking.payment_status || "",
        builder_name: booking.builder?.brand_name || "",
        builder_country_code: booking.builder?.primary_country_code || "",
        builder_contact_number: booking.builder?.primary_contact_number || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(preparedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");
      XLSX.writeFile(workbook, "bookings_data.xlsx");
    } catch (error) {
      alert("Failed to download booking data");
    }
  };

  return (
    <MainLayout>
      <div className="bookings_table">
        <div className="card_container_list">
          <div className="total_card_list">
            <img src={icons["Cancelled"]} alt="Total Card" />
            <h4>
              Total <br />
              Bookings
            </h4>
            <h1>{bookings?.data?.total_bookings || "0"}</h1>
          </div>
          <div className="completed_card_list">
            <img src={icons["Completed"]} alt="Completed Card" />
            <h4>
              Completed <br />
              Bookings
            </h4>
            <h1>{bookings?.data?.total_confirmed_bookings ?? "0"}</h1>
          </div>
          <div className="cancelled_card_list">
            <img src={icons["Processed"]} alt="Cancelled Card" />
            <h4>
              Cancelled <br />
              Bookings
            </h4>
            <h1>{bookings?.data?.total_cancelled_bookings ?? "0"}</h1>
          </div>
        </div>

        <div className="table_component_all">
          <div style={{ gridColumn: "span 5", height: "auto" }}>
            <ListTopSearch
              h3heading="Bookings"
              // filterFunction={filterHandler}
              setState={setSearchQuery}
              onCalendarClick={() => setIsDatePopupVisible(true)}
              onDownloadBooking={canAdd && canEdit ? handleDownloadBookingsExcelWithDateRange : null}
            />
          </div>
          <div
            style={{
              position: "static",
              marginTop: "-69.6px",
              marginLeft: canAdd && canEdit ? "80.5%" : "84.5%",
              marginBottom: "24px",
            }}
          >
            <BookingSourceDropdown
              value={bookingFrom}
              onChange={(e) => setBookingFrom(e.target.value)}
            />
          </div>
          <div style={{ padding: "0px 60px" }}>
            <Table
              dataSource={(Array.isArray(bookings?.data?.result) && bookings.data.result) || []}
              virtual
              scroll={{ x: 1700, y: 500 }}
              pagination={pagination}
              onChange={handleTableChange}
              loading={loading}
              columns={columnsBookings}
            />
          </div>
        </div>
      </div>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </MainLayout>
  );
};

export default ListBookings;
